export enum PartnerEntityTypes {
    company = "company",
    individual = "individual",
    none = "none"
}
